import { AbstractReportPmsApiService } from '../abstract-report.service';
import { UserReconciliation } from "../../../models/reports/daily-activity/user-reconciliation.model";

/**
 * @class UserReconciliationPmsApiService
 * @extends {AbstractReportPmsApiService<UserReconciliation>}
 */
export class UserReconciliationPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/daily-activity/user-reconciliation';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {UserReconciliation}
     * @protected
     */
    newModel(attributes, ...params) {

        return new UserReconciliation(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/user-reconciliation.service.js